import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

export interface IState {
  vatRateList: any;
  updateVatRateStatus: StateStatus | undefined;
  addVatRateStatus: StateStatus | undefined;
  vatRateTypes: any;
}

const initialState: IState = {
  vatRateList: {
    status: null,
    data: null,
  },
  updateVatRateStatus: undefined,
  addVatRateStatus: undefined,
  vatRateTypes: {
    status: null,
    data: null,
  },
};

const VatRateReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_VAT_RATE_LIST:
      return {
        ...state,
        vatRateList: {
          ...state.vatRateList,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.vatRateList.data
              : action.data,
        },
      };
    case Types.SET_VAT_RATE_TYPES:
      return {
        ...state,
        vatRateTypes: {
          ...state.vatRateTypes,
          status: action.status,
          data: action.data === KEEP_THE_SAME ? state.vatRateTypes.data : action.data,
        },
      };
    case Types.SET_UPDATE_VAT_RATE:
      return {
        ...state,
        updateVatRateStatus: action.status,
      };
    case Types.SET_ADD_VAT_RATE:
      return {
        ...state,
        addVatRateStatus: action.status,
      };
    default:
      return {
        ...state,
      };
  }
};

export default VatRateReducer;
